import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "../../../../languages/index.js";
import { SearchIcon } from "@heroicons/react/solid";
import { fetchReports, searchReports } from "../../actions/index";
import _ from "lodash";
import Pagination from "react-js-pagination";
import ReportListItems from "./reportlist-items";
import { Toaster } from "react-hot-toast";
import BaseLoader from "../../../../../common/base-loader";
import TicketsandReportslistTabs from "../ticketreporttabs";
import { classNames } from "../../../../../common/common-functions";

class Reports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // showUploadSection : false,
      loading: true,
      loaderDesc: "Preparing Reports",
      pageNumber: 1,
      searchText: "",
      search: "",
    };

    // All Binded Functions
  }

  componentDidMount() {
    this.props.fetchReports(
      this.props.session,
      this.state.pageNumber,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }

  paginationCallback = (pageNumber) => {
    // alert(pageNumber)
    this.props.fetchReports(
      this.props.session,
      pageNumber,
      (CallBackResponse) => {}
    );
    this.setState({ ...this.state, pageNumber });
  };

  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchReports(
        this.props.session,
        this.state.pageNumber,
        (CallBackResponse) => {}
      );
    } else {
      this.props.searchReports(this.props.session, search);
    }
    this.setState({ search, pageNumber });
  };

  renderList() {
    let pageDataLength = this.props.allReports_listing.data.length;

    let { pageNumber } = this.state;
    // console.log('check');
    var items = _.map(this.props.allReports_listing.data, (values, index) => (
      <ReportListItems
        key={index}
        values={values}
        pagination={this.paginationCallback}
        pageDataLength={pageDataLength}
        currentPage={pageNumber}
      />
    ));
    // console.log('check', this.state.pageNumber);
    return items;
  }
  render() {
    let { language } = this.props;
    return (
      <>
        {this.state.loading ? (
          <>
            <BaseLoader data={this.state.loaderDesc} />
          </>
        ) : (
          <>
            <TicketsandReportslistTabs history={this.props.history} />
            {/* <SearchNewCustomer /> */}
            <div className="relative w-6/12 text-ternary focus-within:text-secondary m-6 mb-0">
              <div
                className={classNames(
                  language == "en" ? "left-0 " : "right-0",
                  "absolute inset-y-0 flex items-center pointer-events-none px-1"
                )}>
                <SearchIcon className="h-5 w-5" aria-hidden="true" />
              </div>
              <input
                id="search-field"
                className={classNames(
                  language == "en" ? "pl-8 pr-3" : "pr-8 pl-3",
                  "block lg:w-6/12 xs:w-full sm:w-full h-full  py-2 border-transparent text-secondary placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm rounded-md"
                )}
                placeholder={LocaleStrings.search}
                type="search"
                name="search"
                value={this.state.search}
                onChange={this.handleSearch}
              />
            </div>
            {_.isEmpty(this.props.allReports_listing.data) ? (
              <>
                <div className="center-item lg:mt-48 text-lg text-ternary">
                  {LocaleStrings.ticketsReports_noReports}
                </div>
              </>
            ) : (
              <>
                <div
                  className="grid gap-4 grid-rows-1 md:grid-rows-3 sm:grid-rows-3 lg:grid-rows-1  px-6"
                  style={{
                    overflowX: "hidden",
                    overflowY: "hidden",
                    display: "block",
                  }}>
                  <div className="panel-body mt-6">
                    <div className="flex flex-col">
                      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-custWhite">
                                <tr>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {LocaleStrings.reportby}
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {LocaleStrings.reportdate}
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {LocaleStrings.reporton}
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {LocaleStrings.report}
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {LocaleStrings.action}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>{this.renderList()}</tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={10}
                      totalItemsCount={this.props.allReports_listing.count}
                      pageRangeDisplayed={10}
                      onChange={this.paginationCallback}
                    />
                  </div>
                  <Toaster />
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, allReports_listing, language } = state;
  return {
    session,
    user,
    language,
    allReports_listing,
  };
}

export default connect(mapStateToProps, {
  fetchReports,
  searchReports,
})(Reports);
